/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {DocumentControlModuleConfig as ɵa} from './libraries/module-config.library';